import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";
import Logo from "@/components/Logo";
import { useApp } from "@/context/AppContext";

export default function Footer() {
  const { settings } = useApp();
  const cols = [
    { title: "Gioco", links: [["Come Funziona", "/come-funziona"], ["Calendario", "/calendario"], ["Classifica", "/classifica"], ["Premi", "/premi"]] },
    { title: "Account", links: [["Registrati", "/registrati"], ["Accedi", "/login"], ["Abbonamento", "/abbonamento"], ["Profilo", "/profilo"]] },
    { title: "Legale", links: [["Regolamento", "/regolamento"], ["Termini e Condizioni", "/termini"], ["Privacy Policy", "/privacy"], ["Cookie Policy", "/cookie-policy"]] },
    { title: "Assistenza", links: [["FAQ", "/faq"], ["Contatti", "/contatti"]] },
  ];
  return (
    <footer className="bg-ink-900 border-t border-gold-300/15 pb-24 lg:pb-10 pt-14 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Logo />
            <p className="text-sm text-muted-foreground mt-4 max-w-xs">La Challenge di pronostici 1-X-2 su Serie A e Champions League. Vinci premi esclusivi ogni 30 giorni.</p>
            <div className="flex gap-3 mt-4">
              <a href={settings?.instagram_url || "https://instagram.com/thekingofresell"} target="_blank" rel="noreferrer" className="btn-outline-gold !p-2.5 !rounded-full" aria-label="Instagram"><Instagram size={18} /></a>
              <a href={`mailto:${settings?.contact_email || "thekingofresell1@gmail.com"}`} className="btn-outline-gold !p-2.5 !rounded-full" aria-label="Email"><Mail size={18} /></a>
            </div>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="font-heading font-bold uppercase tracking-wide text-gold-300 mb-3 text-sm">{c.title}</h4>
              <ul className="space-y-2">
                {c.links.map(([label, to]) => (
                  <li key={to}><Link to={to} className="text-sm text-muted-foreground hover:text-white transition">{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t border-gold-300/10 mt-10 pt-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} The King of Resell — Football Challenge. Tutti i diritti riservati.</p>
          <p>Gioco di abilità su pronostici sportivi. Partecipazione soggetta al regolamento ufficiale.</p>
        </div>
      </div>
    </footer>
  );
}
